import {useSelector} from 'react-redux';

export const useLobbyHelp = (step) => {
  const helpStep = useSelector(s => s.worlds.helpStep);
  return helpStep === step;
};
